module.exports = __webpack_public_path__ + "resource/static/img/batb.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/batb.png
// module id = DHiL
// module chunks = 1